import { render } from "./networking.k8s.io.networkpolicy.vue?vue&type=template&id=5005224d&scoped=true"
import script from "./networking.k8s.io.networkpolicy.vue?vue&type=script&lang=js"
export * from "./networking.k8s.io.networkpolicy.vue?vue&type=script&lang=js"

import "./networking.k8s.io.networkpolicy.vue?vue&type=style&index=0&id=5005224d&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5005224d"]])

export default __exports__